import Search from '@/components/Search';
import useIsMaxScreen from '@/hooks/useIsMaxScreen';
import useIsMediumScreen from '@/hooks/useIsMediumScreen';
import { GetSearchOptionsResponse } from '@/request/interface/resources';
import { getSearchOptions } from '@/request/resources';
import { objToQuery } from '@/utils/url';
import { useRouter } from 'next/router';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

const ResourceSearch = ({ backgroundColor, value = '' }: { backgroundColor?: string; value?: string }) => {
  const [searchVal, setSearchVal] = useState<string>(value);
  const isMediumScreen = useIsMediumScreen();
  const isMaxScreen = useIsMaxScreen();
  const router = useRouter();
  const selectOptionsRef = useRef<GetSearchOptionsResponse['content']>();
  const { i18n } = useTranslation(['resources']);

  const getWidth = () => {
    if (isMediumScreen) {
      return 360;
    }
    if (isMaxScreen) {
      return 435;
    }
    return `calc(100vw - 2.5rem)`;
  };

  const toSearchPage = (val: string) => {
    const params = objToQuery({ q: val });
    if (router.asPath.includes('/resources/search')) {
      router.replace(`/resources/search/${params}`);
    }
    router.push(`/resources/search/${params}`);
  };

  const toDetailPage = (val: string) => {
    if (selectOptionsRef.current) {
      const { uuid, seoUrl } = selectOptionsRef.current?.find(({ name }) => name === val) || {};
      window.open(`/${i18n.language}/resources/${seoUrl}_${uuid}detail/`, '_blank');
    }
  };

  return (
    <Search
      width={getWidth()}
      value={searchVal}
      onChange={setSearchVal}
      onSelect={toDetailPage}
      onSearch={toSearchPage}
      backgroundColor={backgroundColor}
      getSearchOptions={async (value: string) => {
        const options = await getSearchOptions(value);
        selectOptionsRef.current = options;
        return options?.map?.(({ name }) => name) || [];
      }}
    />
  );
};

export default ResourceSearch;
